import React, { useState } from "react";
import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import PropTypes from "prop-types";
import ArtistModal from "../ArtistModal";
import {
  jaidenArray,
  specterArray,
  plasticPenArray,
  fleckArray,
} from "../utils/ArtistModalImageArray";

import { env } from "@bkry/bowline-utils";
const { REACT_APP_CDN_PATH } = env;

const ArtistTabsGenesis = (props, context) => {
  const [activeTab, setActiveTab] = useState("1");

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <Row className="d-flex justify-content-between bigger-margin-top">
      <h2 className="text-center h1 mb-5 pb-0 pb-lg-5">
        {context.t("artist.tabs.genesis.title")}
      </h2>
      <Nav tabs className="d-flex justify-content-center border-bottom-0">
        <NavItem className="mx-1 mx-lg-3 my-2 my-lg-0">
          <NavLink
            className={
              activeTab === "1"
                ? "active text-white bg-secondary btn-outline-primary border rounded-pill"
                : "cursor-pointer btn-outline-primary border rounded-pill"
            }
            onClick={() => toggleTab("1")}
          >
            <span className="ms-1">{context.t("Jaiden Stipp")}</span>
          </NavLink>
        </NavItem>
        <NavItem className="mx-1 mx-lg-3 my-2 my-lg-0">
          <NavLink
            className={
              activeTab === "2"
                ? "active text-white bg-secondary btn-outline-primary border rounded-pill"
                : "cursor-pointer btn-outline-primary border rounded-pill"
            }
            onClick={() => toggleTab("2")}
          >
            <span className="ms-1">{context.t("Specter")}</span>
          </NavLink>
        </NavItem>
        <NavItem className="mx-1 mx-lg-3 my-2 my-lg-0">
          <NavLink
            className={
              activeTab === "3"
                ? "active text-white bg-secondary btn-outline-primary border rounded-pill"
                : "cursor-pointer btn-outline-primary border rounded-pill"
            }
            onClick={() => toggleTab("3")}
          >
            <span className="ms-1">{context.t("Plastic Pen")}</span>
          </NavLink>
        </NavItem>
        <NavItem className="mx-1 mx-lg-3 my-2 my-lg-0">
          <NavLink
            className={
              activeTab === "4"
                ? "active text-white bg-secondary btn-outline-primary border rounded-pill"
                : "cursor-pointer btn-outline-primary border rounded-pill"
            }
            onClick={() => toggleTab("4")}
          >
            <span className="ms-1">{context.t("Thomas Fleck")}</span>
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab} className="mb-3">
        <TabPane tabId="1">
          <Row className="bigger-margin-top d-flex flex-column justify-content-center align-items-center">
            <Col xs={12}>
              <h1 className="text-center pb-5">
                {context.t("artist.jaiden.subtitle")}
              </h1>
              <img
                src={
                  (REACT_APP_CDN_PATH || "") +
                  "/images/Jaiden/1300/1300x433_Hero_Jaiden.jpg"
                }
                alt="artist"
                height="auto"
                width="100%"
              />
            </Col>
            <Col xs={12} lg={8} className="mt-5">
              <h3 className="text-center pb-4">{context.t("Jaiden Stipp")}</h3>
              <p className="text-center">{context.t("artist.jaiden.text")}</p>
              <div className="d-flex justify-content-center">
                <ArtistModal
                  subHeader={context.t("artist.modal.jaiden.subHeader")}
                  headline={context.t("artist.modal.jaiden.headline")}
                  text={context.t("artist.modal.jaiden.text")}
                  items={jaidenArray}
                  twitter="https://twitter.com/jastidesigns"
                  insta="https://www.instagram.com/jastidesigns/?hl=de"
                />
              </div>
            </Col>
          </Row>
        </TabPane>
        <TabPane tabId="2">
          <Row className="bigger-margin-top d-flex flex-column justify-content-center align-items-center">
            <Col xs={12}>
              <h1 className="text-center pb-5">
                {context.t("artist.specter.subtitle")}
              </h1>
              <img
                src={
                  (REACT_APP_CDN_PATH || "") +
                  "/images/Specter/1300/1300x433_Hero_Specter.png"
                }
                alt="artist"
                height="auto"
                width="100%"
              />
            </Col>
            <Col xs={12} lg={8} className="mt-5">
              <h3 className="text-center pb-4">{context.t("Specter")}</h3>
              <p className="text-center">{context.t("artist.specter.text")}</p>
              <div className="d-flex justify-content-center">
                <ArtistModal
                  subHeader={context.t("artist.modal.specter.subHeader")}
                  headline={context.t("artist.modal.specter.headline")}
                  text={context.t("artist.modal.specter.text")}
                  items={specterArray}
                  twitter="https://twitter.com/SpecterBerlin"
                  insta="https://www.instagram.com/specter/?hl=de"
                />
              </div>
            </Col>
          </Row>
        </TabPane>
        <TabPane tabId="3">
          <Row className="bigger-margin-top d-flex flex-column justify-content-center align-items-center">
            <Col xs={12}>
              <h1 className="text-center pb-5">
                {context.t("artist.plastic_pen.subtitle")}
              </h1>
              <img
                src={
                  (REACT_APP_CDN_PATH || "") +
                  "/images/Stefan/1300/1300x433_Hero_Stefan.png"
                }
                alt="artist"
                height="auto"
                width="100%"
              />
            </Col>
            <Col xs={12} lg={8} className="mt-5">
              <h3 className="text-center pb-4">
                {context.t("Stefan Grosse Halbuer")}
              </h3>
              <p className="text-center">
                {context.t("artist.plastic_pen.text")}
              </p>
              <div className="d-flex justify-content-center">
                <ArtistModal
                  subHeader={context.t("artist.modal.plastic_pen.subHeader")}
                  headline={context.t("artist.modal.plastic_pen.headline")}
                  text={context.t("artist.modal.plastic_pen.text")}
                  items={plasticPenArray}
                  twitter="https://twitter.com/grossehalbuer"
                  insta="https://www.instagram.com/plastic.pen/?hl=de"
                />
              </div>
            </Col>
          </Row>
        </TabPane>
        <TabPane tabId="4">
          <Row className="bigger-margin-top d-flex flex-column justify-content-center align-items-center">
            <Col xs={12}>
              <h1 className="text-center pb-5">
                {context.t("artist.thomas.subtitle")}
              </h1>
              <img
                src={
                  (REACT_APP_CDN_PATH || "") +
                  "/images/Thomas/1300/1300x433_Hero_Thomas.png"
                }
                alt="artist"
                height="auto"
                width="100%"
              />
            </Col>
            <Col xs={12} lg={8} className="mt-5">
              <h3 className="text-center pb-4">{context.t("Thomas Fleck")}</h3>
              <p className="text-center">{context.t("artist.thomas.text")}</p>
              <div className="d-flex justify-content-center">
                <ArtistModal
                  subHeader={context.t("artist.modal.thomas.subHeader")}
                  headline={context.t("artist.modal.thomas.headline")}
                  text={context.t("artist.modal.thomas.text")}
                  items={fleckArray}
                  insta="https://www.instagram.com/atmogram/?hl=de"
                />
              </div>
            </Col>
          </Row>
        </TabPane>
      </TabContent>
    </Row>
  );
};

/**  define proptype for the 'translation' function  */
ArtistTabsGenesis.contextTypes = {
  t: PropTypes.func,
};

ArtistTabsGenesis.propTypes = {};

ArtistTabsGenesis.defaultProps = {};

export default ArtistTabsGenesis;
